import React from "react";
import styles from "./header.module.css";

function Header({ gameNameTH }) {
  return (
    <div className={styles.head}>
      <h1 className={styles.h1}>{gameNameTH}</h1>
    </div>
  );
}

export default Header;
